import React from 'react';
import { Route } from 'react-router-dom';
import UnauthenticatedComponent from '../UnauthenticatedComponent';

interface IPublicRouteProps {
  component: any;
  path: any;
  exact?: boolean;
}

const PublicRoute = ({
  component: Component,
  ...rest
}: IPublicRouteProps) => (
  <Route
    {...rest}
    render={(props) => (
      <UnauthenticatedComponent {...props}>
        <Component {...props} />
      </UnauthenticatedComponent>
    )}
  />
);

export default PublicRoute;
